import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { required, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

import { ApplicationEnum } from "../../../enums/ApplicationEnum";
import { formatDate } from "../../../common/vue-helpers/modifiers/value-modifier";
import { ReadmitHc } from "../../vue-models/readmit-hc";
import { PhysiciansService } from "../../../services/physician-service";
import { IGetPhysiciansHC } from "../../../interfaces/i-get-physician";
import { LookupService } from "../../../services/lookup-service";
import { PatientService } from "../../../services/patient.service";
import { ToastrService } from "../../../services/toastr.service";
import { BranchesService } from "../../../services/branches-service";

import DatePicker from "../../vue-custom-elements/DatePicker/DatePicker.vue";
import FormSection from "../../vue-custom-elements/FormSection/FormSection.vue";
import TimePicker from "../../vue-custom-elements/TimePicker/TimePicker.vue";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        DatePicker,
        FormSection,
        TimePicker
    },

    validations() {
        return {
            reAdmit: {
                ReferralDate: { required },
                ReAdmissionDate: { required },
                ClinicianId: { required: requiredIf(!this.isNonMedical) },
                CaseManagerId: { required: requiredIf(!this.isNonMedical) }
            }
        };
    },

    data(vm) {
        return {
            _branchservice: null,
            _toastrService: null,
            _patientService: null,
            _physicianService: null,
            _lookupService: null,
            dialogReference: this.dialogRef as any,
            isNonMedical: false as boolean,
            application: ApplicationEnum.HomeCare,
            accountId: "",
            patientId: "",
            reAdmit: new ReadmitHc(),
            physicianList: null as IGetPhysiciansHC[],
            caseManagersList: null as IGetPhysiciansHC[],
            clinicians: null as IGetPhysiciansHC[],
            isLoading: false,
            branches: [],
            branchName: "",
            v$: useVuelidate(),
            formatDate
        };
    },

    async created() {
        this._branchservice = Container.instance.get(BranchesService);
        this._toastrService = Container.instance.get(ToastrService);
        this._patientService = Container.instance.get(PatientService);
        this._physicianService = Container.instance.get(PhysiciansService);
        this._lookupService = Container.instance.get(LookupService);
        this.isNonMedical = this.dialogReference.data.isNonMedical;
        this.accountId = this.dialogReference.data.accountId;
        this.reAdmit.AgencyId = this.dialogReference.data.accountId;
        this.reAdmit.PatientId = this.dialogReference.data.patientId;
        this.branchName = this.dialogReference.data.branchName;
        const payload = {
            agencyId: this.accountId,
            application: this.application
        };
        this.isLoading = true;
        this.physicianList = await this._physicianService.getPhysiciansListHC(payload);
        if (!this.isNonMedical) {
            this.caseManagersList = await this._lookupService.getCaseManagerListHC(payload);
            this.clinicians = await this._lookupService.getCliniciansList(payload);
        }
        this.isLoading = false;
        this.branches = await this._branchservice.getAllBranches();
        this.reAdmit.AgencyLocationId = this.branches.find((branch: any) => branch.name === this.branchName).id;
    },

    methods: {
        handleDateChange(date: string, name: string) {
            if (name === "reAdmissionDate") {
                this.reAdmit.ReAdmissionDate = date;
            } else {
                this.reAdmit.ReferralDate = date;
            }
        },

        handleDateInputChange(e: any) {
            if (e.target.name === "reAdmissionDate") {
                this.reAdmit.ReAdmissionDate = e.target.value;
            } else {
                this.reAdmit.ReferralDate = e.target.value;
            }
        },

        changeTime(time: any) {
            this.reAdmit.ReAdmissionHour = time;
        },

        handleCloseForm() {
            this.dialogReference.close("success");
        },

        async reAdmitPatient() {
            const isValid = this.v$.$validate();
            if (isValid) {
                const response = await this._patientService.reAdmitHCPatient(this.reAdmit);
                if (response.isSuccessful) {
                    this._toastrService.success({
                        message: `${response.errorMessage}`
                    });
                }
                this.dialogReference.close("succcess");
            } else {
                this._toastrService.error({
                    title: `Validation Error`,
                    message: "Please fill required fields"
                });
            }
        }
    }
});
